export default class ConferenceEvent {
  constructor(data) {
    const { id, eventId, submitter, created, status, name, eventType } = data;
    this.id = id;
    this.eventId = eventId;
    this.initiator = submitter;
    this.created = created;
    this.status = status;
    this.name = name;
    this.eventType = eventType;
  }
}
